import "./Questions.scss";
import { useCallback, useState } from "react";
import { Answer, QuestionsProps } from "@anoki/fse-common";
import { Button } from "@/components";

export function Questions({
  questions,
  onChangeAnswer,
  onSend,
  values: selectedAnswers,
  openAnswer,
  handleOpenAnswer,
  buttons,
  maxCharactersMessage,
  openAnswerPlaceholder,
  resetFeedback,
}: QuestionsProps) {
  const [currentStep, setCurrentStep] = useState(0);

  const handleAnswerChange = useCallback(
    (questionId: string, answer: Answer) => {
      onChangeAnswer(questionId, answer);
    },
    [onChangeAnswer],
  );

  const onConfirm = () => {
    onSend();
  };

  const handleNext = () => {
    if (!selectedAnswers[currentStep] && questions[currentStep].type !== "OPEN")
      return;

    if (currentStep < questions.length - 1) {
      setCurrentStep(currentStep + 1);
    }

    if (currentStep === questions.length - 1) {
      onConfirm();
    }
  };

  const handlePrevious = () => {
    if (currentStep === 0) {
      resetFeedback?.();
      return;
    }

    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <div className="steppers">
      <div className="steppers-header pb-2  align-items-center">
        <p className={"steppers-header-question-title"}>
          {questions[currentStep].question}
        </p>
        <span className={"steppers-header-question-number"}>
          {currentStep + 1}/{questions.length}
        </span>
      </div>
      <div className="steppers-content" aria-live="polite">
        {questions[currentStep].type === "CLOSE" ? (
          <div className="list-group">
            {questions[currentStep].answers.map((answer, index) => (
              <label
                key={`${questions[currentStep].id}-${index}`}
                htmlFor={`checkbox-${answer.id}`}
                className=" fw-regular fs-6 list-group-item "
              >
                <input
                  type="radio"
                  id={`checkbox-${answer.id}`}
                  name={`question-${currentStep}`}
                  value={answer.answer}
                  checked={
                    selectedAnswers?.[currentStep]?.answer?.includes(answer) ||
                    false
                  }
                  onChange={() =>
                    handleAnswerChange(questions[currentStep].id, answer)
                  }
                  className="custom-control-input form-check-input me-2 black-focus"
                />
                {answer.answer}
              </label>
            ))}
          </div>
        ) : (
          <div className="form-group d-flex flex-column gap-1">
            <input
              type="text"
              placeholder={openAnswerPlaceholder}
              className="form-control black-focus"
              value={openAnswer}
              onChange={(e) =>
                e.target.value.length <= 200 && handleOpenAnswer(e.target.value)
              }
              autoFocus
            />

            <div className="d-flex justify-content-between align-items-center max-chars-container">
              {maxCharactersMessage && (
                <p className=" fs-6 fw-normal ">{maxCharactersMessage}</p>
              )}
              {openAnswer && openAnswer.length > 0 && (
                <p className="active fs-6 fw-normal ">
                  {openAnswer.length}/200
                </p>
              )}
            </div>
          </div>
        )}
      </div>
      <nav className="steppers-nav no-border shadow-none align-items-center justify-content-center gap-4 flex-wrap">
        <Button
          className="feedback-button-back"
          onClick={handlePrevious}
        /* disabled={currentStep === 0} */
        >
          {buttons.previous}
        </Button>

        <Button
          className="feedback-button-next"
          onClick={handleNext}
          disabled={currentStep === questions.length}
        >
          {buttons.next}
        </Button>
      </nav>
    </div>
  );
}
